var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "smesco-fee-setting-form bg-white p-6 rounded-md shadow-sm"
  }, [_c('div', {
    staticClass: "mb-6 border-b pb-4"
  }, [_c('h2', {
    staticClass: "text-xl font-semibold text-neutral-800"
  }, [_vm._v(_vm._s(_vm.isEditMode ? 'Edit Fee Setting' : 'Tambah Fee Setting'))])]), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-1 gap-6 mb-6"
  }, [_c('div', [_vm._m(0), _c('div', {
    staticClass: "relative"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.delivery_service_id,
      expression: "form.delivery_service_id"
    }],
    staticClass: "w-full border border-neutral-300 rounded-md px-4 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-primary-500",
    attrs: {
      "required": ""
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.form, "delivery_service_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Pilih Ekspedisi")]), _vm._l(_vm.deliveryServices, function (service) {
    return _c('option', {
      key: service.id,
      domProps: {
        "value": service.id
      }
    }, [_vm._v(" " + _vm._s(service.name || service.id) + " ")]);
  })], 2)])]), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Fixed Fee (Rp)")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "0",
      "disabled": _vm.form.percentage_fee > 0
    },
    on: {
      "input": _vm.handleFixedFeeInput
    },
    model: {
      value: _vm.form.fixed_fee,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fixed_fee", _vm._n($$v));
      },
      expression: "form.fixed_fee"
    }
  }), _vm.form.percentage_fee > 0 ? _c('span', {
    staticClass: "text-xs text-neutral-500 mt-1 block"
  }, [_vm._v("Dinonaktifkan karena Percentage Fee terisi.")]) : _vm._e()], 1), _c('div', [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Percentage Fee (%)")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "0",
      "disabled": _vm.form.fixed_fee > 0
    },
    on: {
      "input": _vm.handlePercentageFeeInput
    },
    model: {
      value: _vm.form.percentage_fee,
      callback: function ($$v) {
        _vm.$set(_vm.form, "percentage_fee", _vm._n($$v));
      },
      expression: "form.percentage_fee"
    }
  }), _vm.form.fixed_fee > 0 ? _c('span', {
    staticClass: "text-xs text-neutral-500 mt-1 block"
  }, [_vm._v("Dinonaktifkan karena Fixed Fee terisi.")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "flex justify-end gap-4 mt-8 pt-4 border-t border-neutral-200"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Batal",
      "url": "/smesco/fee-setting",
      "linkType": "internal",
      "type": "secondary"
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "type": "primary",
      "disabled": _vm.isLoading,
      "submit": ""
    }
  })], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Delivery Service (Ekspedisi) "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("*")])]);

}]

export { render, staticRenderFns }